<template>
    <app-layout>

        <template #fluid>
            <browse-drawer />
        </template>
       
       <div class="bg-light p-5 text-center">
           Product Not Found
        </div>

    </app-layout>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout'
    import SidebarCategory from '@/Layouts/SidebarCategory'
    import SearchBar from '@/Layouts/SearchBar'
    import BrowseDrawer from '@/Layouts/BrowseDrawer'

    export default {
        components: {
            AppLayout,
            SidebarCategory,
            SearchBar,
            BrowseDrawer,
        }
        
    }
</script>